import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeSharedThemeToggle(): Provider {
  return provideTranslocoScope({
    scope: 'shared-theme-toggle',
    alias: 'sharedTt',
    loader: i18nLoader,
  });
}
